import React from "react";
import { Review } from "./Review";
import { Box, Text } from "@chakra-ui/react";
import moment from "moment";
import { translation } from "../../utils/translation";

export const Reviews = (props) => {
  let reviews = window.translations.reviews;

  let lastGeneratedDate = new Date();

  const reviewsContent = reviews.map((review, index) => {
    const generateReviewDate = () => {
      let daysToDeduct = Math.floor(Math.random() * 4);
      lastGeneratedDate.setDate(lastGeneratedDate.getDate() - daysToDeduct);

      return moment(lastGeneratedDate).format("DD.MM.yyyy");
    };
    return (
      <Review
        key={"review-" + index}
        author={review.author}
        date={review.date.replace("{getDateRandomly}", generateReviewDate())}
        score={review.score}
        review={review.review}
      />
    );
  });

  const totalScore = (reviews) => {
    let totalScore = 0;

    reviews.forEach((review) => {
      totalScore += review.score;
    });

    let avgRating = Math.round((totalScore / reviews.length) * 100) / 100;

    return avgRating.toFixed(1);
  };

  return (
    <>
      <Box align="center">
        <Text fontSize="3xl">
          {translation("general.complete.product.review.headline")}
        </Text>
        <Text fontSize="6xl">{totalScore(reviews)}</Text>
      </Box>

      {reviewsContent}
    </>
  );
};
